var map = {
	"./comment.svg": "03ee",
	"./offline.svg": "058b",
	"./online.svg": "a3a7",
	"./other.svg": "5f34",
	"./pre-sale.svg": "a709",
	"./shopping-cart.svg": "43cc",
	"./sms.svg": "694b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";